// extracted by mini-css-extract-plugin
export default {"FaEmoji":"FaEmoji2k9M5A--aWLg"};